
import { Box } from 'reflexbox/styled-components';

export default Box;

